module.exports = " <div class=row v-if=ready> <div v-if=authorized.database_exportable class=col-xs-12 style=\"margin-bottom: 15px\"> <a href={{exportPath}} class=\"btn btn-primary pull-right\">Export Database</a> </div> <div class=clearfix></div> <yeast-types></yeast-types> <varietals></varietals> <regions></regions> <div class=clearfix></div> <what-now></what-now> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/index.vue
// module id = 467
// module chunks = 2